<h1 mat-dialog-title>{{ videos[currentVideoIndex].title }}</h1>
<div mat-dialog-content>
  <video #videoPlayer width="100%" controls (ended)="onVideoEnd()">
    <source [src]="videoUrl | safe" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <button mat-button (click)="playPreviousVideo()" [disabled]="currentVideoIndex === 0">Previous</button>
  <button mat-button (click)="playNextVideo()" [disabled]="currentVideoIndex === videos.length - 1">Next</button>
  <button mat-button (click)="closeDialog()">Close</button>
</div>